import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const GradientCTA: React.FC = () => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      {/* Bold gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-charcoal via-charcoal to-charcoal" />

      {/* Decorative gradient orbs */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[500px] h-[500px] bg-coral/20 rounded-full blur-[120px] animate-blob" />
      <div className="absolute top-1/4 right-0 w-[400px] h-[400px] bg-teal/15 rounded-full blur-[100px] animate-blob-delay-2" />
      <div className="absolute bottom-0 left-1/3 w-[300px] h-[300px] bg-golden/10 rounded-full blur-[80px] animate-blob-delay-4" />

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-dark mb-8 animate-fade-in">
          <Sparkles className="w-4 h-4 text-coral" />
          <span className="text-sm font-medium text-white/90">Start your transformation today</span>
        </div>

        <h2 className="font-nunito font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6">
          Your Wardrobe,{' '}
          <span className="text-gradient-bright">Reimagined</span>
        </h2>

        <p className="text-lg sm:text-xl text-white/70 mb-10 max-w-2xl mx-auto">
          Whether you're planning a dream vacation, preparing for a special event, or refreshing your everyday style. Get a personalised styling plan in minutes.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/app"
            className="group inline-flex items-center justify-center bg-coral hover:bg-coral/90 text-white rounded-2xl text-lg px-8 py-4 font-semibold transition-all duration-300 hover:shadow-glow-coral hover:scale-105"
          >
            Get Styled Today
            <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center rounded-2xl text-lg px-8 py-4 font-semibold text-white/90 border border-white/20 hover:bg-white/10 transition-all duration-300"
          >
            Explore Services
          </Link>
        </div>

        {/* Micro trust row */}
        <div className="mt-12 flex flex-wrap justify-center gap-x-8 gap-y-3 text-white/50 text-sm">
          <span>No subscription required</span>
          <span className="hidden sm:inline">·</span>
          <span>Reports delivered instantly</span>
          <span className="hidden sm:inline">·</span>
          <span>Money-back guarantee</span>
        </div>
      </div>
    </section>
  );
};

export default GradientCTA;
